"use client";

import { type ActiveFilter, type FilterFieldDef } from "./types";
import { SegmentSelect } from "./segment-select";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const FILTER_CHIP_BADGE_CLASS =
  "h-4 rounded px-1 py-0 text-[10px] leading-none font-medium";

export function FilterSelectValue({
  filter,
  field,
  onUpdate,
}: {
  filter: ActiveFilter;
  field: FilterFieldDef;
  onUpdate: (updated: ActiveFilter) => void;
}) {
  const hasBadges = field.options.some((o) => o.badgeVariant);
  const selected = field.options.find((o) => o.value === filter.value);

  return (
    <div className="flex h-full items-center overflow-hidden">
      <SegmentSelect
        value={filter.value}
        options={field.options}
        onChange={(v) => onUpdate({ ...filter, value: v })}
        className="text-contrast/75 max-w-none"
        maxDropdownHeight={260}
        dropdownContent={
          hasBadges
            ? (opt) => (
                <Badge
                  variant={opt.badgeVariant as never}
                  size="xs"
                  className={cn("rounded-md leading-4", opt.badgeClassName)}
                >
                  {opt.label}
                </Badge>
              )
            : undefined
        }
      >
        {hasBadges && selected?.badgeVariant ? (
          <Badge
            variant={selected.badgeVariant as never}
            size="xs"
            className={cn(
              FILTER_CHIP_BADGE_CLASS,
              selected.badgeClassName,
            )}
          >
            {selected.label}
          </Badge>
        ) : (
          (selected?.label ?? "Select")
        )}
      </SegmentSelect>
    </div>
  );
}
